export const INITIAL_AUTH_STATE = {
  isAuthenticated: false,
  isInitialized: false,
  currentUser: {},
  error: null,
};

export const setUserAthStatusUpdater = (state, { payload }) => ({
  ...state,
  isAuthenticated: payload.isAuthenticated,
  isInitialized: payload.isInitialized ?? state.isInitialized,
  currentUser: payload.userInfo,
  error: payload.error,
});
